import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { styled } from '@mui/system';

import HistorySection from '../../../../components/HistorySection';
import HistoryRowSubHeader from '../../../../components/HistoryRowSubHeader';
import { Container, Item } from '../../../../components/Grid';

import { abilitiesToArray, formatTheDates, IMotorFunctionEvent } from '../../utils';
import HistoryRowBasicItem from '../../../../components/HistoryRowBasicItem';
import DocumentCreationButton from '../../../../components/DocumentCreationButton';
import { EditHistoryDialogStandAlone } from 'Components/HistoryRowControls/EditHistory/EditHistoryDialog';

const StyledItem = styled('div')({
  marginBottom: '1rem',
});

const eventsItem = (event: IMotorFunctionEvent): React.JSX.Element => (
  <Item xs={4}>
    <StyledItem>
      <HistoryRowBasicItem
        header={<FormattedMessage id={'motorFunctionAndMobilityAid.motorfunction.' + event.name} />}
        value={formatTheDates(event.start, event.end)}
      />
    </StyledItem>
  </Item>
);

const MotorFunctionHistory = ({ documents, startEdit }: IOwnProps): React.JSX.Element => {
  const [gainedAbilities, setGainedAbilities] = React.useState<Array<IMotorFunctionEvent>>([]);
  const [lostAbilities, setLostAbilities] = React.useState<Array<IMotorFunctionEvent>>([]);

  React.useEffect(() => {
    const arrayAbilities = abilitiesToArray(documents);

    setGainedAbilities(arrayAbilities.gained);
    setLostAbilities(arrayAbilities.lost);
  }, [documents]);

  const motorfunctionDocument = documents?.length > 0 ? documents[0] : undefined;
  return (
    <HistorySection
      headerText={<FormattedMessage id={'motorFunctionAndMobilityAid.motorfunction.title'} />}
      newButton={
        <>
          <DocumentCreationButton
            name="motorfunction"
            document={motorfunctionDocument}
            text={'general.edit'}
            onClick={startEdit(motorfunctionDocument ?? {}, 'motorfunction')}
            width={15}
            height={3}
            fontSize={14}
            alternate={true}
          />
          <EditHistoryDialogStandAlone key={'edit'} document={motorfunctionDocument} />
        </>
      }
    >
      {documents && (
        <React.Fragment>
          {gainedAbilities.length > 0 && (
            <>
              <HistoryRowSubHeader
                header={<FormattedMessage id="motorFunctionAndMobilityAid.motorfunction.gainedAbilities" />}
              />
              <Container>
                {gainedAbilities.map(event => (
                  <React.Fragment key={event.name}>{eventsItem(event)}</React.Fragment>
                ))}
              </Container>
            </>
          )}
          {lostAbilities.length > 0 && (
            <>
              <HistoryRowSubHeader
                header={<FormattedMessage id="motorFunctionAndMobilityAid.motorfunction.lostAbilities" />}
              />
              <Container>
                {lostAbilities.map(event => (
                  <React.Fragment key={event.name}>{eventsItem(event)}</React.Fragment>
                ))}
              </Container>
            </>
          )}
        </React.Fragment>
      )}
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IMotorFunction[];
  startEdit: (document: IMotorFunction | {}, name?: string) => (e: React.MouseEvent<Element, MouseEvent>) => void;
}

export default MotorFunctionHistory;
